import React from 'react';
import { useTrafficMonitor } from '../utils/useTrafficMonitor.ts';

interface TrafficMonitorWrapperProps {
  children: React.ReactNode;
}

export function TrafficMonitorWrapper({ children }: TrafficMonitorWrapperProps) {
  // Enable traffic monitoring for the entire app
  useTrafficMonitor({ trackPageViews: true });

  return <>{children}</>;
} 